import styles from "./Cupons.Desconto.module.scss";

import { ICupom } from "shared/interfaces/ICupom";
import CupomItem from "shared/components/cupomitem/CupomItem";

import { useEffect, useMemo, useState } from "react";

import {
  buscarCuponsPorUsuario,
  buscarCuponsGlobais,
} from "shared/services/api/cupons.api";

import PageContainer from "shared/components/pagecontainer/PageContainer";

import { Ticket } from "lucide-react";

import { useSearchParams } from "react-router-dom";

import { buscadorCuponsConfig } from "shared/config/buscadorConfigs";

export const CuponsDesconto: React.FC = () => {
  const [loading, setLoading] = useState(true);

  const [listaCupons, setListaCupons] = useState<ICupom[]>([]);

  const [searchParams] = useSearchParams();

  const busca =
    searchParams.get("search")?.toLowerCase().trim() || "";

  /* ================================
     CARREGAR CUPONS
  ================================ */

  useEffect(() => {
    async function carregarCupons() {
      try {
        setLoading(true);

        const globais = await buscarCuponsGlobais();

        const lojista = await buscarCuponsPorUsuario();

        const todos = [
          ...globais,
          ...lojista,
        ];

        /* ================================
           CUPONS GLOBAIS PRIMEIRO
        ================================ */

        todos.sort((a, b) =>
          a.tipo === "global"
            ? -1
            : 1
        );

        setListaCupons(todos);

      } catch (error) {
        console.error(
          "Erro ao carregar cupons:",
          error
        );
      } finally {
        setLoading(false);
      }
    }

    carregarCupons();
  }, []);

  /* ================================
     FILTRAR CUPONS
  ================================ */

  const cuponsFiltrados = useMemo(() => {
    if (!busca) {
      return listaCupons;
    }

    return listaCupons.filter((cupom) => {
      const codigo =
        String(cupom.code ?? "").toLowerCase();

      const descricao =
        String(cupom.descricao ?? "").toLowerCase();

      return (
        codigo.includes(busca) ||
        descricao.includes(busca)
      );
    });
  }, [listaCupons, busca]);

  /* ================================
     ESTADOS VAZIOS
  ================================ */

  const cuponsVazio =
    !loading &&
    listaCupons.length === 0;

  const nenhumResultado =
    !loading &&
    listaCupons.length > 0 &&
    cuponsFiltrados.length === 0;

  return (
    <PageContainer
      title="Cupons de Desconto"
      icon={<Ticket size={22} />}
      showDesktopSearch={true}
      desktopSearchProps={buscadorCuponsConfig}
    >

      <div className={styles.page}>

        {/* LOADING */}

        {loading && (
          <p>Carregando cupons...</p>
        )}

        {/* NENHUM CUPOM CADASTRADO */}

        {cuponsVazio && (
          <>
            <div className={styles.containerImg}>
              <img
                src="/imagens/semloja.png"
                alt="Nenhum cupom cadastrado"
              />
            </div>

            <h2 className={styles.vazio}>
              Não há cupons.
            </h2>
          </>
        )}

        {/* NENHUM RESULTADO DA BUSCA */}

        {nenhumResultado && (
          <div className={styles.vazioBusca}>
            <h2>
              Nenhum cupom encontrado
            </h2>

            <p>
              Tente buscar por outro código
              ou descrição.
            </p>
          </div>
        )}

        {/* LISTA */}

        {!loading &&
          cuponsFiltrados.map(
            (cupom: ICupom, index: number) => (
              <CupomItem
                key={cupom.uid}
                cupom={cupom}
                numeroUI={(index + 1)
                  .toString()
                  .padStart(4, "0")}
                modo="simples"
              />
            )
          )}

      </div>

    </PageContainer>
  );
};